module.exports = __webpack_public_path__ + "assets/img/9ba3-kp.svg";